 <template>
    <div class="flex-grow mt-6">
        <div class="pb-1 mb-2 md:mb-5">
            <h3 class="font-medium leading-5 text-gray-900 text-md">
                Suggested Distributors
            </h3>
        </div>
        <div>
            <div
                v-for="(distributor) in searchResults"
                :key="distributor.id"
                class="flex justify-between mt-1 bg-white border border-gray-200 rounded-lg shadow"
                >
                <a
                    :href="distributor.route"
                    class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                >

                    <div class="flex items-center px-4 py-3 sm:py-4 sm:px-6">
                        <div class="flex items-center flex-1 min-w-0">
                            <div class="flex-shrink-0">
                                <img
                                    class="w-8 h-8 rounded-full md:h-12 md:w-12"
                                    :src="distributor.thumbnail"
                                    alt=""
                                    loading="lazy"
                                >
                            </div>
                            <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-2 md:gap-4">
                                <div class="col-span-3 space-y-1">
                                    <div class="flex space-x-2 text-sm font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 lg:text-md visited:text-indigo-800">
                                        <span v-html="distributor.name_edge_ngram"></span>
                                        <span
                                            v-if="distributor.type"
                                            class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide"
                                            :class="{
                                                'bg-green-100 text-green-800': distributor.type == 'principal',
                                                'bg-gray-100 text-gray-800': distributor.type != 'principal',
                                            }"
                                        >
                                            <span v-html="distributor.type_edge_ngram"></span>
                                        </span>
                                    </div>
                                    <div class="flex space-x-2 text-sm sm:text-md">
                                        <div
                                            v-if="distributor.distributorship_name"
                                            class="flex items-center leading-5 text-gray-500"
                                        >
                                            {{ distributor.distributorship_name }}
                                        </div>
                                        <div
                                            v-if="distributor.city_state_edge_ngram"
                                            class="flex items-center leading-5 text-gray-500 sm:mt-0"
                                        >
                                            <svg
                                                class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                            <p v-html="distributor.city_state_edge_ngram"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </a>
                <span v-if="inDistributors(distributor.id)" class="inline-flex p-2 mr-2">
                    <span class="hidden text-sm md:inline-flex">
                        Added
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-flex w-5 h-5 ml-1 text-green-600">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </span>
                <span v-else>
                    <button class="hidden mr-2 tw-button-green md:justify-end md:mr-4 md:block" @click="addToProfile(distributor.id)">
                        Add
                    </button>
                    <button class="block w-6 h-6 mr-2 text-center bg-green-600 rounded-full hover:bg-green-700 justify-items-center md:hidden" @click="addToProfile(distributor.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                    </button>
                </span>
            </div>
            <div class="flex justify-between flex-1 mt-2 sm:justify-end">
            <a v-if="!isFirstPage" @click="decrementPage" class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                Previous
            </a>
            <a v-if="!isLastPage" @click="incrementPage" class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
                Next
            </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
        props: {
            searchFilters: {
                type: [Array, Object],
                required: true,
            },
            searchRoute: {
                type: String,
                required: true,
            },
            model: {
                type: [Array, Object],
                required: true,
            },
            distributors: {
                type: [Array, Object],
                required: false,
            }
        },
        created() {
            this.loadItems();
        },
        computed: {
            isFirstPage() {
                if (this.serverParams.page === 0) {
                    return true;
                }
                return false
            },
            isLastPage() {
                var numPages = Math.ceil(this.total/this.serverParams.pageSize);
                if (this.serverParams.page + 1 === numPages) {
                    return true;
                }
                return false
            },
        },
        data () {
            return {
                searchResults: {},
                serverParams: {
                    searchTerm: '',
                    filters: {},
                    pageSize: 10,
                    page: 0,
                },
                total: 0,
            }
        },
        methods: {
            async loadItems() {
                this.serverParams.filters = this.searchFilters;
                try {
                    const response = await axios.get(this.searchRoute, { params: this.serverParams });
                    this.searchResults = response.data.results;
                    this.total = response.data.totalRows;
                    console.log(this.searchResults);
                    this.isLoading = false;

                } catch (error) {
                    this.rows = [];
                    this.isLoading = false;
                    return false;
                }

                return true;
            },
            addToProfile(distributor_id) {
                this.$emit('add-to-profile', distributor_id);
            },
            inDistributors(distributor_id) {
                if (this.distributors.length > 0) {
                    let ids = this.distributors.map(distributor => distributor.id)
                    return ids.includes(distributor_id);
                }
                return false;
            },
            getPaginationLowerBound() {
                return (this.serverParams.page*this.serverParams.pageSize) + 1;
            },
            getPaginationUpperBound() {
                var bound = (this.serverParams.page + 1)*this.serverParams.pageSize;
                if (bound <= this.total) {
                    return bound;
                } else {
                    return this.total;
                }
            },
            incrementPage() {
                this.serverParams.page = this.serverParams.page + 1;
                this.loadItems();
            },
            decrementPage() {
                this.serverParams.page = this.serverParams.page - 1;
                this.loadItems();
            },
        }
    }
</script>
